module.exports = __webpack_public_path__ + "6c5a3750b26dd1135ccfd6cf653f4091.png";